export default {
    rem2px: function(rem){
        var fontsize = document.documentElement.clientWidth / 750;
        return fontsize * rem;
    },
    getNavBarHeightWithInt: function(){
        return this.rem2px(88);
    },
    getNavBarHeight: function(){
        return this.getNavBarHeightWithInt() + 'px';
    },
    getTitleHeightWithInt: function(){
        return this.rem2px(188);
    },
    getTitleHeight: function(){
        return this.getTitleHeightWithInt() + 'px';
    },
    setScrollShadow: function(value){
        if(typeof value == 'boolean' && value){
            return { boxShadow: `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,0.76)` };
        }else if(value > 0){
            let n = value / 260 * 0.76;
            n = n > 0.76 ? 0.76 : n;
            return { boxShadow: `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,${n})` };
        }else{
            return {};
        }
    },
    getAbnormalDate: function(value, fmt = 'yyyy年MM月dd日'){
		if(!['yyyy年MM月dd日', 'yyyy-MM-dd'].includes(fmt))return;
		let dateText = '';
		if(typeof value == 'number'){
			let dateStr = value.toString();
			let year = dateStr.substr(0,4),
				month = dateStr.substr(4,2),
				day = dateStr.substr(6,2);
			let dates = [];
			if(+year){ dates.push(year); }
			if(+month){ dates.push(month); }
			if(+day){ dates.push(day); }
			if(fmt == 'yyyy年MM月dd日'){
				let b = '年月日';
				dateText = dates.map((item,index)=>item + b[index]).join('');
			}else{
				dateText = dates.join('-');
			}
		}
		return dateText;
	}
}